import all from '../selectors/all.js'
import append from '../tree/append.js'
import before from '../tree/before.js'
import body from '../tree/body.js'
import after from '../tree/after.js'
import prepend from '../tree/prepend.js'
import remove from '../tree/remove.js'
import replaceChildren from '../tree/replaceChildren.js'
import replaceWith from '../tree/replaceWith.js'
import object from '../utils/object.js'

const clone = node => node.cloneNode(true)
const cloneAll = nodes => nodes.map(clone)

const contents = element => {
  const { childNodes, nodeName } = element
  
  return [...(nodeName === 'SLOT') ? childNodes : [element]]
}

const update = (element, selector, body, tasks, task) => {
  const { ownerDocument } = element
  const nodes = contents(element)
  
  remove(element)
  
  for (const match of all(selector, ownerDocument)) {
    const clones = cloneAll(nodes)
    
    append(body, clones)
    tasks.push(() => task(match, clones))
  }
}

const updaters = object(null, {
  ':scope > [data-after]': (element, body, tasks) => {
    const { dataset } = element
    const { after: selector } = dataset
    
    delete dataset.after
    update(element, selector, body, tasks, after)
  },
  ':scope > [data-append]': (element, body, tasks) => {
    const { dataset } = element
    const { append: selector } = dataset
    
    delete dataset.append
    update(element, selector, body, tasks, append)
  },
  ':scope > [data-before]': (element, body, tasks) => {
    const { dataset } = element
    const { before: selector } = dataset
    
    delete dataset.before
    update(element, selector, body, tasks, before)
  },
  ':scope > [data-empty]': element => {
    const { dataset, ownerDocument } = element
    const { empty: selector } = dataset
    
    for (const match of all(selector, ownerDocument)) {
      replaceChildren(match)
    }
  },
  ':scope > [data-prepend]': (element, body, tasks) => {
    const { dataset } = element
    const { prepend: selector } = dataset
    
    delete dataset.prepend
    update(element, selector, body, tasks, prepend)
  },
  ':scope > [data-remove]': element => {
    const { dataset, ownerDocument } = element
    const { remove: selector } = dataset
    
    remove(element)
    
    for (const match of all(selector, ownerDocument)) {
      remove(match)
    }
  },
  ':scope > [data-replace]': (element, body, tasks) => {
    const { dataset } = element
    const { replace: selector } = dataset
    
    delete dataset.replace
    update(element, selector, body, tasks, replaceWith)
  },
  ':scope > [data-replace-children]': (element, body, tasks) => {
    const { dataset } = element
    const { replaceChildren: selector } = dataset
    
    delete dataset.replaceChildren
    update(element, selector, body, tasks, replaceChildren)
  }
})

const selectors = Object.keys(updaters)

export default container => {
  const { ownerDocument } = container
  const target = body()
  const tasks = []
  
  if (!ownerDocument.contains(container)) {
    for (const selector of selectors) {
      for (const match of all(selector, container)) {
        updaters[selector](match, target, tasks)
      }
    }
  }
  
  return {
    target,
    update: () => {
      for (const task of tasks) {
        task()
      }
    }
  }
}
